function OnStartFetchRdc() {
    const onStartFetchRdc = (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true });
    };
    return onStartFetchRdc;
}
export default OnStartFetchRdc;
//# sourceMappingURL=OnStartFetchRdc.js.map